import _ from 'lodash';
import {getSeriesNameForSort, sortString} from '../../../../../../services/Helpers';


export const isEventChecked = (courses, seriesId, eventId) =>
    ((courses ?? []).find(course => course.series_id === seriesId)?.series_event_ids ?? []).includes(eventId);

const isEventFull = (series, eventId) =>
    !series.openDays?.some(openDay => openDay.id === eventId);

const isEventBooked = (series, eventId) => {
    const bookedIds = series?.booked_series_event_ids ?? series?.bookedSeriesEventIds;
    if (bookedIds?.length) {
        return bookedIds.includes(eventId);
    }
    if (series?.isBookedUser) {
        return true;
    }
    const event = (series?.series_events ?? []).find(item => item.id === eventId);
    return !!(event?.isBookedUser || event?.is_booked_user);
};

export const isEventDisabled = ({series, eventId, courses, trackSessionPerWeek, courseSessionPerWeek}) => {
    if (isEventFull(series, eventId) || isEventBooked(series, eventId)) {
        return true;
    }

    const selectedIds = (courses ?? []).find(course => course.series_id === series.id)?.series_event_ids ?? []
    if (selectedIds.includes(eventId)) {
        return false;
    }
    const selectedCount = (courses ?? []).reduce((sum, course) => sum + (course.series_event_ids?.length ?? 0), 0);
    if (selectedCount >= trackSessionPerWeek) {
        return true;
    }
    if (courseSessionPerWeek != null && selectedIds.length >= courseSessionPerWeek) {
        return true;
    }

    return false;
};

export const getTrackCoursesSelection = ({courses, trackCourses, trackSessionPerWeek}) => {
    const isEmpty = !trackCourses?.length;
    let availableCount = 0;

    for (const course of trackCourses ?? []) {
        const series = course.series;
        let availableInCourse = 0;
        for (const event of series?.series_events ?? []) {
            if (!isEventFull(series, event.id) && !isEventBooked(series, event.id)) {
                availableCount++;
                availableInCourse++;
            }
        }
    }

    const requiredCount = trackSessionPerWeek
    const selectedCount = (courses ?? []).reduce((sum, course) => sum + (course.series_event_ids?.length ?? 0), 0);
    const canProceed = !isEmpty && requiredCount > 0 && selectedCount >= requiredCount;

    return {
        availableCount,
        requiredCount,
        selectedCount,
        isEmpty,
        canProceed,
    };
};

export const groupTrackCoursesByCategory = (trackCourses) => {
    const sortedTrackCourses = _.sortBy(
        trackCourses ?? [],
        trackCourse => sortString(getSeriesNameForSort(trackCourse.series?.series_name)),
    );
    const grouped = _.groupBy(sortedTrackCourses, relation => relation.series?.box_categories?.name ?? '');
    const sortedKeys = _.sortBy(Object.keys(grouped), categoryName => sortString(categoryName));
    return _.fromPairs(sortedKeys.map(categoryName => [categoryName, grouped[categoryName]]));
};
